<app-modal>
    <ng-container title>
        {{ model.titleLanguageKey | translate }}
    </ng-container>
    <ng-container body>
        <p *ngIf="model.bodyLanguageKey">
            {{ model.bodyLanguageKey | translate: model.bodyParams }}
        </p>
    </ng-container>
    <ng-container footer>
        <button *ngIf="model.cancelLanguageKey" (click)="onCancel()">
            {{ model.cancelLanguageKey | translate }}
        </button>
        <button class="primary" (click)="onConfirm()">
            {{ model.confirmLanguageKey | translate }}
        </button>
    </ng-container>
</app-modal>
